import React, { Fragment } from 'react';
import moment from 'moment';
import Lottie from 'react-lottie';
// child components
import PnrFormComponent from '../../components/pnr-form/pnr-form.component';
import StatusDetailsComponent from '../../components/status-details/status-details.component';
import BookingItemsComponent from '../../components/booking-items/booking-items.component';
import HighlightInfoComponent from '../../components/highlight-info/highlight-info.component';
// product service
import BookingProductService from '../../services/booking-product.service';
import { replaceParameters } from 'src/services/string-helper';
// styles
const styles = require('./pre-slot-status.scss');
// images
const headerInbound = require('../../images/preslot_inbound_header.svg');
// animations
const animationData = require('./lottie-animation.json');
declare var exponea: any;
interface IProps {
  trackingData: any;
  queryParams: any;
  language: string;
  languageCode: string;
  multiLang: any;
  airlineCode: string;
  airlineName: string;
  passengerRules: any;
}

interface IState {
  meetingPoint: any;
  lottieOptions: any;
  loaded: boolean;
}

class PreSlotStatusComponent extends React.Component<IProps, IState> {

  private product = null;
  public bookingProductService = null;

  constructor(props: any) {
    super(props);
    this.state = {
      meetingPoint: props.trackingData.airportPreSlotTrackingStatus !== null
        ? props.trackingData.airportPreSlotTrackingStatus.airportPickUpCopy
        : null,
      lottieOptions: {
        animationData: animationData,
        loop: true,
        autoplay: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      },
      loaded: false
    };
  }

  componentDidMount() {
    this.bookingProductService = new BookingProductService(this.props.trackingData.trackingBookingDetails, this.props.trackingData.collectionSlot);
    this.product = this.bookingProductService.returnProductDetails();
    this.setState({ loaded: true });
    exponea.track('tracking_screen', { 'page_name': 'PreSlot', 'product_type': 'abc'});
  }

  componentWillReceiveProps(props: IProps) {
    if (props.trackingData !== null) {
      this.setState({
        meetingPoint: props.trackingData.airportPreSlotTrackingStatus !== null
          ? props.trackingData.airportPreSlotTrackingStatus.airportPickUpCopy
          : null
      });
    }
  }

  meetingPointInfo() {
    const { language, multiLang } = this.props;

    return (
      <div className={styles.meetingPoint}>
        <h2>{multiLang[`whereDoIFindYou${language}`]}</h2>
        <p>{this.state.meetingPoint.intro}</p>
        <p className={styles.meetingPointLocation}>
          {this.state.meetingPoint.terminal}<br />
          {this.state.meetingPoint.areaLine1}<br />
          {this.state.meetingPoint.areaLine2}
        </p>
        <p>{this.state.meetingPoint.areaDetails}</p>
        <p><a className={styles.btnPrimary} href={this.state.meetingPoint.maplink} target='_blank'>View map</a></p>
      </div>
    )
  }

  public render() {
    const { trackingData, queryParams, language, multiLang, airlineCode, passengerRules, languageCode } = this.props;
    const { loaded, meetingPoint, lottieOptions } = this.state;
    const driverData = trackingData.driverTrackingStatus;
    const joborderInfo = driverData?.translation ? driverData.translation.message : driverData?.text ? driverData.text : '';
    const parameters = driverData?.translation ? driverData.translation.parameters : {};
    let displayDriverJobInfo = false;

    if (parameters?.driverJobOrderNumber && trackingData?.collectionSlot !== null) {
      const collectionSlot = moment(trackingData.collectionSlot.dateTime);
      const now = moment();
      const diffInHours = collectionSlot.diff(now, 'hours');
      // if difference is less than 3 hours show job order number
      if (diffInHours < 3 && +parameters.customerJobOrderNumber > 1) {
        displayDriverJobInfo = true;
      } else if (diffInHours < 3 && +parameters.driverJobOrderNumber > 0) {
        displayDriverJobInfo = true;
      }
    }
    return (
      <Fragment>
        {loaded ?
          <div className={styles.mainContent}>
            <div className={styles.sectionWrapperHero}>
              <div className={styles.section}>
                {/* copy: pending for placeholder*/}
                {/* copy with replacement */}
                <h1>{multiLang[`${trackingData.displayMessage}${language}`]}</h1>
                {displayDriverJobInfo && joborderInfo && <h2>{joborderInfo ? replaceParameters(multiLang[`${joborderInfo}${language}`], parameters) : '' }</h2>}
                {trackingData.aksSlot?.slot && <h1 className={styles.textPrimary}>{trackingData.aksSlot?.slot}, {trackingData.aksSlot?.dateTimeTextDisplay}</h1>}
                {(this.product === 1 || this.product === 3) || (this.product !== 1 && this.product !== 3 && trackingData.collectionSlot === null)
                  ? <div className={styles.heroOutbound}><Lottie options={lottieOptions}></Lottie></div>
                  : <img className={styles.heroInbound} src={headerInbound} />
                }
              </div>
            </div>
            <div className={styles.sectionWrapperContent}>
              <div className={styles.section}>
                <StatusDetailsComponent
                  language={language}
                  multiLang={multiLang}
                  data={trackingData.collectionSlot !== null ? trackingData.collectionSlot : trackingData.deliverySlot}
                  displayMessage={trackingData.displayMessage}>
                </StatusDetailsComponent>
                {trackingData.pnrBookingData.showPNRField === true && trackingData.pnrBookingData.isPNRStored === false
                  ? <PnrFormComponent
                    language={language}
                    multiLang={multiLang}
                    bookingReference={queryParams.bookingRef}
                    emailAddress={queryParams.email}
                    airlineCode={this.props.airlineCode}
                    airlineName={this.props.airlineName}>
                    </PnrFormComponent>
                  : null
                }
                {meetingPoint !== null
                  ? this.meetingPointInfo()
                  : null
                }
                {this.product === 1 || this.product === 2 || this.product === 5 || this.product === 6
                  ? <HighlightInfoComponent screen={'preSlot'} airlineCode={airlineCode} passengerRules={passengerRules} languageCode={languageCode} trackingData={trackingData} language={language} multiLang={multiLang} headerCenter={false}></HighlightInfoComponent>
                  : null
                }
                <BookingItemsComponent language={language} multiLang={multiLang} data={trackingData}></BookingItemsComponent>
              </div>
            </div>
          </div>
          : null}
      </Fragment>
    );
  }

}

export default PreSlotStatusComponent;



// WEBPACK FOOTER //
// ./src/containers/pre-slot/pre-slot-status.component.tsx